export const autoScrollerOptions = {
  startFromPercentage: 0.2, // Start auto-scrolling when the draggable is 20% away from the container edge
  maxScrollAtPercentage: 0.05, // Maximum scroll speed reached when 5% away from the edge
  maxPixelScroll: 15, // Smooth and slow scrolling speed (pixels per frame)
  ease: (percentage: number) => Math.pow(percentage, 1.5), // Gentle easing with a slight acceleration
  durationDampening: {
    stopDampeningAt: 200, // Dampening reduces scroll intensity for 200ms
    accelerateAt: 400 // Acceleration starts after 400ms for a smoother experience
  },
  disabled: false // Ensure auto-scrolling is enabled
};
